<script setup>
import { computed } from 'vue'
import UiSelect from '@/Components/UI/UiSelect.vue'

const props = defineProps({
  modelValue: { type: String, default: '' }, // "HH:MM"
  minuteStep: { type: Number, default: 5 },
})
const emit = defineEmits(['update:modelValue'])

const parts = computed(() => {
  const m = /^(\d{2}):(\d{2})$/.exec(props.modelValue || '')
  return m ? { h: m[1], m: m[2] } : { h: '', m: '' }
})

const hourOptions = computed(() =>
  Array.from({ length: 24 }, (_, i) => {
    const v = String(i).padStart(2, '0')
    return { value: v, label: v }
  })
)

const minuteOptions = computed(() => {
  const step = Math.max(1, props.minuteStep)
  const out = []
  for (let i = 0; i < 60; i += step) {
    const v = String(i).padStart(2, '0')
    out.push({ value: v, label: v })
  }
  const cur = parts.value.m
  if (cur && !out.some(o => o.value === cur)) {
    out.push({ value: cur, label: cur })
    out.sort((a, b) => a.value.localeCompare(b.value))
  }
  return out
})

const setHour = (h) => {
  const m = parts.value.m || '00'
  emit('update:modelValue', `${h}:${m}`)
}
const setMinute = (m) => {
  const h = parts.value.h || '00'
  emit('update:modelValue', `${h}:${m}`)
}
</script>

<template>
  <div class="inline-flex items-center gap-1">
    <UiSelect
      :model-value="parts.h"
      :options="hourOptions"
      placeholder="HH"
      @update:model-value="setHour"
    />
    <span class="text-[color:var(--muted)] px-0.5">:</span>
    <UiSelect
      :model-value="parts.m"
      :options="minuteOptions"
      placeholder="MM"
      @update:model-value="setMinute"
    />
  </div>
</template>

<style scoped>
.inline-flex > :deep(.flex.flex-col) { width: 4.5rem; }
</style>
